export const API_BASE_URLS = {
  BASE_URL: import.meta.env.VITE_BASE_API_URL,
  DATA_MANAGEMENT_API_URL: import.meta.env.VITE_DATA_MANAGEMENT_API_URL,
  MY_DATA_CLIENT_URL: import.meta.env.VITE_MY_DATA_CLIENT_URL,
} as const;
